export async function PostCallWithErrorResponse(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

// PUT twin of PostCallWithErrorResponse — same JSON headers, same "Token"
// key, same {response, json, error} shape. PutCallWithAuthToken below reads
// the lowercase "token" key instead, which the CRM APIs don't use.
export async function PutCallWithErrorResponse(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function simplePostCallForm(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //'Access-Control-Allow-Credentials': "*"
      Authorization: 'Bearer ' + localStorage?.getItem("Token"),
      customer_id: localStorage?.getItem("customer_id"),
      user_id: localStorage?.getItem("userId")
    },
    // withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}



export async function fetchPOST(url, data = {}, headers = {}) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers, // Merge custom headers if needed (e.g., auth)
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("POST request error:", error.message);
    throw error;
  }
}

export async function PetchCallWithErrorResponse(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function PostCallWithErrorResponseReqBody(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}


export async function simplePatchCall(url, requestBody) {
  try {
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("Token"),
      },
      withCredentials: true,
      body: JSON.stringify(requestBody),
    });

    const result = await response.text();
    return getResult(result);
  } catch (error) {
    console.error("Error making PATCH request:", error);
    throw error;
  }
}

export async function simpleGetCallWithToken(url) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },


  })

    .then((response) => response.text())
    .then((result) => getResult(result))
    .catch((err) => {
      console.error("catch error,", err);
    });

}

export async function simpleGetCallWithTokenNoNBEARER(url) {
  try {
    const response = await fetch(url, {
      method: "GET", // HTTP GET request
      headers: {
        Authorization: "Bearer " + localStorage.getItem("Token"),
        "Content-Type": "application/json", // Adjust if needed
      },
    });
    const responseData = await response.json(); // Parse JSON response
    return responseData; // Return the JSON response
  } catch (error) {
    console.error("Error:", error);
    //throw error; // Re-throw the error to be handled by the caller
  }
}
export async function DeleteCallWithErrorResponseWithToken(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function DeleteCallWithErrorResponseWithTokenQuery(url) {
  var resp;
  // const [progress, setProgress] = useState(0);
  // const { customerData } = useContext(AppContext);

  return await fetch(url, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    // body: JSON.stringify({...customerData,...requestBody})
    // body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function deleteWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "DELETE",

    headers: {
      Accept: "application/json",

      "Content-Type": "application/json",

      Authorization: "Bearer " + localStorage.getItem("Token"),
    },

    body: requestBody,
  }).then((response) => response.json());
}

export async function multipartPostCallWithErrorResponse(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",

      // "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function getWithAuthCallWithErrorResponse(url) {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    })
    .catch((err) => console.log("catch error,", err));
}

export async function getWithRequestBodyWithErrorResponse(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // Authorization: "Token " + localStorage.getItem("USER_AUTH_TOKEN"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function postWithAuthCallWithErrorResponse(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
      // "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function putMultipartWithAuthCallWithErrorResponse(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      //'Content-Type': 'multipart/form-data',
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function postMultipartWithAuthCallWithErrorResponse(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "POST",

    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

// XHR-based multipart upload that surfaces real-time progress. fetch() doesn't
// expose upload progress events, so large file uploads gave the user no visual
// feedback. Use this helper anywhere we need a progress bar; the response
// shape ({response, json, error}) matches postMultipartWithAuthCallWithErrorResponse
// so call sites can swap in/out without other changes.
export function postMultipartWithProgress(url, requestBody, onProgress) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader(
      "Authorization",
      "Bearer " + localStorage.getItem("Token")
    );

    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable || typeof onProgress !== "function") return;
      // Cap mid-flight at 99 — bytes are on the wire but the server may still
      // be writing/scanning before it acks. The wrapper is removed on response,
      // so the brief pause at 99 is the honest signal.
      const raw = (event.loaded / event.total) * 100;
      const percent = raw >= 100 ? 99 : Math.round(raw);
      onProgress(percent, event.loaded, event.total);
    };

    const finalize = (ok, status) => {
      let json = null;
      try {
        json = xhr.responseText ? JSON.parse(xhr.responseText) : null;
      } catch (_) {
        json = null;
      }
      resolve({
        response: { ok, status },
        json,
        error: !ok,
      });
    };

    xhr.onload = () => {
      const ok = xhr.status >= 200 && xhr.status < 300;
      finalize(ok, xhr.status);
    };
    xhr.onerror = () => finalize(false, 0);
    xhr.onabort = () => finalize(false, 0);

    xhr.send(requestBody);
  });
}

export async function simpleGetCallWithErrorResponse(url) {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    })
    .catch((error) => {
      console.log("catch error res,", error);
    });
}



export async function patchMultipartWithAuthCall(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
    redirect: 'follow',
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function simpleGetCall(url, extraHeaders = {}) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
      ...extraHeaders,
    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result))
    .catch((err) => {
      console.error("catch error,", err);
    });
}

export async function getRequest(url) {
  try {
    const response = await fetch(url, {
      method: "GET", // HTTP GET request
      headers: {
        "Content-Type": "application/json", // Adjust if needed
        Authorization: "Bearer " + localStorage.getItem("Token"),
      },
    });
    const responseData = await response.json(); // Parse JSON response
    return responseData; // Return the JSON response
  } catch (error) {
    console.error("Error:", error);
    //throw error; // Re-throw the error to be handled by the caller
  }
}

export async function simplePostCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
      // Origin: window.location.origin,
      //'Access-Control-Allow-Credentials': "*"

    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
  //.then(data=>data.json());
}

export async function simplePostCallIVT(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //'Access-Control-Allow-Credentials': "*"
      Authorization: "Bearer " + localStorage.getItem("Token"),

    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function multipartPostCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      //'Content-Type': 'multipart/form-data',
      // 'Authorization': 'Token ' + await AsyncStorage.getItem(AppStrings.TOKEN)
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function getWithAuthCall(url) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
      Authorization: "Bearer " + localStorage.getItem("Token"),

    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function postWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
      // Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function putWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}




export async function putRequest(url, body) {
  try {
    const response = await fetch(url, {
      method: "PUT", // Change to 'GET', 'POST', 'DELETE', etc. if needed
      headers: {
        "Content-Type": "application/json", // Adjust headers as needed
        Authorization: "Bearer " + localStorage.getItem("Token"),
      },
      body: body, // Convert the body to a JSON string
    });
    const responseData = await response.json(); // Parse JSON response
    return responseData; // Return the JSON response
  } catch (error) {
    console.error("Error:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
}

export async function putMultipartWithAuthCallWithErrorResponseAdmin(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      //'Content-Type': 'multipart/form-data',
      Authorization: "JWT " + JSON.parse(localStorage.getItem("token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function postRequest(url, body) {
  try {
    const response = await fetch(url, {
      method: "POST", // Change to 'GET', 'PUT', 'DELETE', etc. if needed
      headers: {
        Authorization: "Bearer " + localStorage.getItem("Token"),
        "Content-Type": "application/json", // Adjust headers as needed
      },
      body: body, // Convert the body to a JSON string
    });
    const responseData = await response.json(); // Parse JSON response
    return responseData; // Return the JSON response
  } catch (error) {
    console.error("Error:", error);
    //  throw error; // Re-throw the error to be handled by the caller
  }
}

export async function putMultipartWithAuthCallWithErrorResponseAdminNew(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      //'Content-Type': 'multipart/form-data',
      Authorization: "JWT " + JSON.parse(localStorage.getItem("token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function postMultipartRequestAdmin(url, formData) {
  try {
    const response = await fetch(url, {
      method: "POST", // HTTP POST request
      body: formData, // Directly use the FormData object
      headers: {
        // Optionally, include custom headers if needed
        // For example, if you need to include an authentication token:
        Authorization: "JWT" + " " + JSON.parse(localStorage.getItem("token")),
        Accept: "application/json", // Indicate the response format you're expecting
        //"Content-Type": "multipart/form-data", // Typically not needed, fetch sets this automatically
      },
    });

    // if (!response.ok) {
    //   throw new Error(`HTTP error! Status: ${response.status}`);
    // }

    const responseData = await response.json(); // Parse JSON response
    return responseData; // Return the JSON response
  } catch (error) {
    console.error("Error:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
}

export async function postMultipartWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}


export async function postMultipartWithAuthCallINT(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      // "Content-Type": "multipart/form-data",
      // "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + localStorage.getItem("Token"),

    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}
export async function PostCallWithAuthToken(url, requestBody) {
  var resp;
  const Token = localStorage.getItem("token");
  console.log("Token in auth token call is ", Token);
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    })
    .catch((error) => {
      console.log("error,", error);
    });
}

export async function putMultipartWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      // "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function updateProfile(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      // Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.token)),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function simplePostTokenCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
      //'Access-Control-Allow-Credentials': "*"
      Authorization: localStorage?.getItem("Token"),
      user_customer_id: localStorage?.getItem("customer_id"),
      user_id: localStorage?.getItem("id")
    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

//-------------------------------------
export async function getResult(data) {
  return JSON.parse(data.trim());
}
//-------------------------------------


export async function PutCallWithAuthToken(url, requestBody) {
  var resp;
  const Token = localStorage.getItem("token")
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${Token}`,
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function putCallWithFormData(url, requestBody) {
  var resp;
  const Token = localStorage.getItem("token")
  return await fetch(url, {
    method: "PUT",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${Token}`,
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export const downloadReport = async (url,fileName,type='xlsx') => {
  try {


    const res = await fetch(url, {
      method: "GET",
      headers: {
        // include auth if your other calls do — check what the helper adds
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
      },
    });

    if (!res.ok) throw new Error(`Download failed: ${res.status}`);

    const blob = await res.blob(); // read as blob, NOT json
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `${fileName}.${type}`; // filename + extension
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error(err);
  }
};